export default {
  GET_REQUIRED: 'GET_REQUIRED',
  GET_ANALYTICS: 'GET_ANALYTICS',
  GET_MARKETING: 'GET_MARKETING',
  GET_FACEBOOK_PIXEL: 'GET_FACEBOOK_PIXEL',
  GET_ACCEPT_ALL_URL: 'GET_ACCEPT_ALL_URL',
  GET_ACCEPT_SELECTED_URL: 'GET_ACCEPT_SELECTED_URL',
}
